import client from "../../graphql/client";
import { loader } from "graphql.macro";

const setOrganisationLabelsMutation = loader("../../graphql/mutations/adminOrganisationSetLabels.graphql");

export default function setOrganisationLabelsAction(organisationId, tagIds) {
    return () => {
        return client.mutate({
            mutation: setOrganisationLabelsMutation,
            variables: { organisationId, tagIds }
        });
    };
}
